/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ExamHeartbeatSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('EXAM_HEARTBEAT')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class ExamHeartbeatSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ExamHeartbeatSettingParser.decode(input).map(res => new ExamHeartbeatSetting(res));
    }
    static unsafeDecode(input) {
        return ExamHeartbeatSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExamHeartbeatSettingParser.encode(data);
    }
    static schema() {
        return ExamHeartbeatSettingParser.schema();
    }
}
